/**
 * ExtractionLoadingState Component
 *
 * Loading spinner with AI-themed styling shown during recipe extraction.
 */

/**
 * Sparkle icon for AI-themed styling
 */
function SparkleIcon() {
  return (
    <svg
      className="w-6 h-6 text-blue-600"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
      />
    </svg>
  );
}

/**
 * Spinner icon for loading animation
 */
function SpinnerIcon() {
  return (
    <svg
      className="animate-spin h-8 w-8 text-blue-600"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

/**
 * Loading state component for recipe extraction
 */
export function ExtractionLoadingState() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-12 text-center" data-testid="loading" aria-busy="true">
      {/* Spinner */}
      <div className="flex justify-center mb-4">
        <SpinnerIcon />
      </div>

      {/* Message */}
      <div className="flex items-center justify-center gap-2 mb-2">
        <SparkleIcon />
        <h3 className="text-lg font-medium text-gray-900">
          Extracting recipe with AI...
        </h3>
      </div>

      <p className="text-sm text-gray-600">
        This may take a few moments
      </p>
    </div>
  );
}
